module.exports = __webpack_public_path__ + "img/join-bg (3).7fd27c3c.jpg";